
import { Voni } from '../client';
import { PerformanceMetric, MetricsBatch } from '../types';


export interface TrackEvent {
  project_id: string;
  session_id: string;
  event: string;
  properties?: Record<string, unknown>;
}

export interface AnalyticsStats {
  period: string;
  total_conversations: number;
  total_messages: number;
  active_users: number;
  avg_session_duration: number;
  // Add other fields as returned by the API
  [key: string]: unknown;
}

export class AnalyticsResource {
  constructor(private client: Voni) { }

  async getStats(projectId: number, days: number = 30): Promise<AnalyticsStats> {
    return this.client.request<AnalyticsStats>('GET', '/signals/stats', { project_id: projectId, days });
  }

  async getRealtimeStats(projectId: number): Promise<Record<string, unknown>> {
    return this.client.request<Record<string, unknown>>('GET', '/signals/realtime-stats', { project_id: projectId });
  }

  async getOrchestratorStats(projectId: number): Promise<Record<string, unknown>> {
    return this.client.request<Record<string, unknown>>('GET', '/signals/orchestrator-stats', { project_id: projectId });
  }

  async track(event: TrackEvent): Promise<void> {
    await this.client.request('POST', '/signals/track', undefined, event);
  }

  async postMetrics(metrics: MetricsBatch): Promise<Record<string, unknown>> {
    return this.client.request<Record<string, unknown>>('POST', '/signals/metrics', undefined, metrics);
  }
}
